// extracted by mini-css-extract-plugin
module.exports = {"byline":"ByLine_byline__swns3","name":"ByLine_name__gRFug"};